module.exports = __webpack_public_path__ + "img/setor-serigrafia-acao-camisetas.e9632c84.png";